import React from 'react'
import PropTypes from 'prop-types'

export const VerifiedIcon = ({ className }) => {
  return (
    <svg
      className={className}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 0C10.7664 0 0 10.7664 0 24C0 37.2336 10.7664 48 24 48C37.2336 48 48 37.2336 48 24C48 10.7664 37.2336 0 24 0ZM19.2024 34.5912L10.2912 25.6992L13.68 22.3008L19.1976 27.8088L31.9032 15.1032L35.2968 18.4968L19.2024 34.5912Z"
        fill="#00BB31"
      />
    </svg>
  )
}

VerifiedIcon.propTypes = {
  className: PropTypes.string,
}
